import React, { useState, useEffect } from "react";
import "../Assests/Scss/Participation.scss";
import {
  AssessmentName, CAssessmentName,
  Assessmentdate,
} from "../../Student/Reusablecomponents/RegularFunctions";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import { RiFileExcel2Fill } from "react-icons/ri";
import Loading from "../../Student/Reusablecomponents/Loading";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import NLineTrends from "./NLineTrends";
import RLineTrends from "./RLineTrends";
// import * as XLSX from "xlsx";
import XLSX from "xlsx-js-style";
import { AllSubjectData } from "../../Redux/Reducers/HQAdmin/PerformanceOverallSubjects";
import { Testcolors } from "../../ReusableComponents/CommonFunctions";
const PerformanceTable = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);

  const [Load, SetLoad] = useState(false);
  const [NSData, SetNSData] = useState([]);
  const [RegionP, SetRegionP] = useState();
  const [Subjects, SetSubjects] = useState();
  const [SelectSUb, SetSelectSub] = useState();
  const [RegId, SetRegId] = useState();
  // Data for other regions can be added here

  const NationalPerformance = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/InstitutionAdmin/GetNationalPerformance?ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}&InstituteId=${items?.instituteId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].subjectName) {
          NationalRegionPerformance();
          SetNSData(res.data);
        } else {
          SetNSData(process.env.REACT_APP_NODATAFOUND_Participated);
          // SetSubjects();
          // SetSelectSub();
          SetLoad((prev) => !prev);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const NationalRegionPerformance = async () => {
    // SetLoad(prev => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/InstitutionAdmin/GetRegionPerformance?ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}&InstituteId=${items?.instituteId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const regions = [...new Set(res.data.map((item) => item.region))];
        const regionIDs = Array.from(
          res.data
            .reduce(
              (map, item) =>
                map.set(item.region, {
                  display: item.region,
                  value: item.regionId,
                }),
              new Map()
            )
            .values()
        );
        SetRegId(regionIDs);
        const subjects = [...new Set(res.data.map((item) => item.subjectName))];
        const regionData = regions.map((region) => {
          const regionSubjects = res.data.filter(
            (item) => item.region === region
          );
          const subjectPercentages = subjects.reduce((acc, subject) => {
            acc[subject] =
              regionSubjects.find((item) => item.subjectName === subject)
                ?.percentage || "N/A";
            return acc;
          }, {});
          return { region, ...subjectPercentages };
        });

        SetRegionP(regionData);
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (SelectDate?.value > 0) {
      if (items?.userTypeId !== 8) {
        NationalPerformance();
      } else {
        //  StatePerformance();
      }
    } else {
      SetNSData(process.env.REACT_APP_NODATAFOUND_Participated);
    }
  }, [SelectDate?.value]);

  const OPenRegionDrillDown = (RegionName) => {
    const value = RegId.filter((item) => item.display === RegionName);
    dispatch(AllSubjectData({ RegionDetails: value }));
    // localStorage.setItem("PerformanceDate", JSON.stringify(GetAssessmentdate));
    navigate(`/InstitutionAdmin/Performance/RegionPerformanceDetails`);
  };
//  4th May 2026 Export the table data in Excel Format
  const exportToExcel = () => {
    const table = document.getElementById("performanceTable");
    if (!table) {
      alert("Table not found!");
      return;
    }

    const worksheet = XLSX.utils.table_to_sheet(table, { raw: true });
    const range = XLSX.utils.decode_range(worksheet["!ref"]);

    for (let R = range.s.r; R <= range.e.r; R++) {
      for (let C = range.s.c; C <= range.e.c; C++) {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });

        if (!worksheet[cellAddress]) continue;

        worksheet[cellAddress].s = {
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
      }
    }

    if (worksheet["A1"]) {
      worksheet["A1"].s = {
        ...worksheet["A1"].s,
        font: {
          bold: true,
        },
        alignment: {
          horizontal: "center",
          vertical: "center",
        },
      };
    }
    if (worksheet["A4"]) {
      worksheet["A4"].s = {
        ...worksheet["A4"].s,
        font: {
          bold: true,
        },
      };
    }

    for (let C = range.s.c; C <= range.e.c; C++) {
  const cellAddress = XLSX.utils.encode_cell({
    r: 1,
    c: C,
  });

  if (!worksheet[cellAddress]) continue;

  worksheet[cellAddress].s = {
    ...worksheet[cellAddress].s, 
    font: {
      ...(worksheet[cellAddress].s?.font || {}),
      bold: true,
    },
    alignment: {
      horizontal: "center",
      vertical: "center",
    },
  };
}

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Performance");

    XLSX.writeFile(workbook, `National_Performance ${SelectDate?.assessmentTypeName}_${SelectDate?.examStartDate}.xlsx`);
  };
  return (
    <>
      <div className="TeacherBgImage">
        <InternetChecking />
<div className="dflex JSBetween alignitems">
  <div></div>
        <div className="MainHeading">
          National Performance in {CAssessmentName(SelectDate?.assessmentType)} - {SelectDate?.examStartDate}
        </div>
        {/*   4th May 2026 Trigger the export excel function */}
        <div className="ExportExcel" onClick={() => exportToExcel()}>{NSData?.[0]?.subjectName &&  <RiFileExcel2Fill />} </div>
        </div>
        <div className="Table-Card mt-2">
          {NSData?.[0]?.subjectName ? (
            <table className="w-100 Inst_Performance-Table" id="performanceTable">
              <thead>
                <tr>
                  <th colSpan={NSData?.length + 1} style={{ color: "#205680" }}>
                    {" "}
                    National performance{" "}
                  </th>
                </tr>
                <tr>
                  <th></th>
                  {NSData?.map((item, index) => (
                    <th key={index}>{item.subjectName}(%)</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr style={{ color: "#7030a0" }}>
                  <th className="ft-18">National</th>
                  {NSData?.map((item, index) => (
                    <td key={index}>{item.percentage}%</td>
                  ))}
                </tr>
                <tr>
                  <th
                    colSpan={NSData?.length + 1}
                    style={{ textAlign: "justify" }}
                  >
                    Region performance:
                  </th>
                </tr>
                {RegionP?.map((item, index) => (
                  <tr key={index} >
                    <th
                      className="text-decoration-underline CPointer"
                      // style={{ color: "#259957" }}
                      style={{ color: "#008080" }}
                      onClick={() => {
                        OPenRegionDrillDown(item.region);
                      }}
                    >
                      {item.region}
                    </th>
                    {NSData?.map((Subject, index) => (
                      <td key={index}>
                        {item[Subject.subjectName] !== "N/A"
                          ? item[Subject.subjectName] + "%"
                          : "-"}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="ErrorMessage">{NSData}</div>
          )}
        </div>

        <div className="SubHeading mt-3">
          National vs Region performance trends
        </div>

        <div className="container-fluid">
          <Row className=" Card mt-3 dflex" style={{ gap: "10px" }}>
            <div className="dflex RegionSub-Navigations">
              {Subjects?.map((item, index) => (
                <span
                  key={index}
                  onClick={() => {
                    SetSelectSub(item);
                  }}
                  style={
                    SelectSUb !== item
                      ? { color: "#878997", backgroundColor: "#f5f5f5" }
                      : {}
                  }
                >
                  {item}
                </span>
              ))}
            </div>
            <Col style={{ borderRight: "1px solid #CBCBCB" }}>
              {" "}
              <NLineTrends
                AType={SelectDate?.assessmentType}
                SubSelect={SelectSUb}
                StoreSubjects={SetSubjects}
                StoreSelSub={SetSelectSub}
              />{" "}
            </Col>
            <Col>
              {" "}
              <RLineTrends
                AType={SelectDate?.assessmentType}
                Regions={RegId}
                SubSelect={SelectSUb}
              />{" "}
            </Col>
          </Row>
        </div>
        {/* <CopyRight /> */}
      </div>
      {Load && <Loading />}
    </>
  );
};
export default PerformanceTable;
